import { Box } from '@chakra-ui/react';
import { useMemo } from 'react';
import { useGameColorsProvider } from 'src/providers/Theme/gameColorsProvider';
import { BuyStages } from '../getGame';

export const TransactionLoadingBar = ({ stage }: { stage: BuyStages }) => {
	const { callToActionColor, callToActionTextColor } = useGameColorsProvider();

	const percent = useMemo(() => {
		switch (stage) {
			case BuyStages.BOUGHT:
				return 100;
			case BuyStages.BUYING:
				return 75;
			case BuyStages.APPROVED:
				return 50;
			case BuyStages.APPROVING:
				return 25;
			case BuyStages.NOT_STARTED:
				return 0;
			default:
				return 0;
		}
	}, [stage]);

	return (
		<Box
			mt="-4px"
			mb="5px"
			h="8px"
			position="relative"
			w="100%"
		>
			<Box
				position="absolute"
				w="100%"
				h="100%"
				opacity="0.5"
				bg={`repeating-linear-gradient(
					to right,
					${callToActionColor} 0px,
					${callToActionColor} 2px,
					transparent 2px,
					transparent 6px
					);
				`}
			></Box>
			<Box
				position="absolute"
				w={`${percent}%`}
				transition="1s width"
				h="100%"
				bg={callToActionColor}
			/>
			<Box
				position="absolute"
				w={`${percent}%`}
				transition="1s width"
				h="100%"
				filter="blur(6px)"
				bg={callToActionColor}
			/>
		</Box>
	);
};
